import { Button, Container, Divider, Typography } from "@material-ui/core";
import React, { useState } from "react";
import AccessPermission from "./AccessPermission";
import NoChangeError from "./NoChangeError";
import RoleDetails from "./RoleDetails";
import SuccessScreen from "./SuccessScreen";

//send as prop from dashboard
// const departmentAPI = {
//   departmentDetailsList: [
//     {
//       departmentID: 1,
//       departmentName: "Human Resources",
//       departmentType: "Administrative",
//       RolesList: [
//         {
//           collaborator_role_id: 101,
//           roleName: "HR Manager",
//         },
//         {
//           collaborator_role_id: 102,
//           roleName: "Recruiter",
//         },
//       ],
//     },
//     {
//       departmentID: 2,
//       departmentName: "Engineering",
//       departmentType: "Technical",
//       RolesList: [
//         {
//           collaborator_role_id: 201,
//           roleName: "Software Engineer",
//         },
//         {
//           collaborator_role_id: 202,
//           roleName: "DevOps Engineer",
//         },
//         {
//           collaborator_role_id: 203,
//           roleName: "QA Engineer",
//         },
//       ],
//     },
//     {
//       departmentID: 3,
//       departmentName: "Marketing",
//       departmentType: "Sales",
//       RolesList: [
//         {
//           collaborator_role_id: 301,
//           roleName: "Marketing Manager",
//         },
//         {
//           collaborator_role_id: 302,
//           roleName: "Content Strategist",
//         },
//       ],
//     },
//   ],
// };
export default function CreateNewRole({
  setOpen,
  departmentAPI,
  handleRefresh,
}) {
  // console.log("🚀 ~ CreateNewRole ~ departmentAPI:", departmentAPI);
  const wrappedDepartmentAPI = { departmentDetailsList: [...departmentAPI] };
  const [showComponent, setShowComponent] = React.useState("RoleDetails");
  const [count, setCount] = useState({
    enabled: 0,
    disabled: 0,
  });
  const [roleInfo, setRoleInfo] = useState({
    department: "",
    roleName: "",
    roleDescription: "",
    roleType: "Default",
  });

  const displayComponent = () => {
    switch (showComponent) {
      case "RoleDetails":
        return (
          <RoleDetails
            setShowComponent={setShowComponent}
            setOpen={setOpen}
            roleInfo={roleInfo}
            setRoleInfo={setRoleInfo}
            departmentAPI={wrappedDepartmentAPI}
          // departmentAPI={[]}
          />
        );
      case "AccessPermission":
        return (
          <AccessPermission
            setShowComponent={setShowComponent}
            departmentAPI={wrappedDepartmentAPI}
            roleInfo={roleInfo}
            setCount={setCount}
          />
        );
      case "NoChangeError":
        return <NoChangeError setShowComponent={setShowComponent} />;
      case "SuccessScreen":
        return (
          <SuccessScreen
            setShowComponent={setShowComponent}
            handleRefresh={handleRefresh}
            setOpen={setOpen}
            roleInfo={roleInfo}
            count={count}
          />
        );
      default:
        return null;
    }
  };

  return (
    <Container style={{ minHeight: "100%" }}>
      <Typography
        style={{ marginTop: "10px", fontSize: "16px", fontWeight: 500 }}
        gutterBottom
      >
        Create New Role
      </Typography>
      <Divider style={{ height: "2px", backgroundColor: "black" }} />
      {displayComponent()}
    </Container>
  );
}
